module.exports = __webpack_public_path__ + "428d31c385afd676cc72cd8031b67542.svg";